import TitleView from '@plone/volto/components/manage/Blocks/Title/View';
import cx from 'classnames';
import Breadcrumbs from '@plone/volto/components/theme/Breadcrumbs/Breadcrumbs';
import FormattedDate from '@plone/volto/components/theme/FormattedDate/FormattedDate';

const OnlyTitleBodyTemplate = (props) => {
  const { content } = props;

  return (
    <div className={cx('block pageheader has-no-image', props.className)}>
      {props.breadcrumbPath && (
        <div className="pageheader-breadcrumbs">
          <Breadcrumbs pathname={props.breadcrumbPath} />
        </div>
      )}
      {content?.['@type'] === 'News Item' && (
        <div className="dates">
          {content.effective ? (
            <FormattedDate
              key="day"
              date={content.effective}
              format={{
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              }}
              className="day"
            />
          ) : null}
        </div>
      )}
      <div className="pageheader-text">
        <TitleView {...props} />
      </div>
    </div>
  );
};

export default OnlyTitleBodyTemplate;
